module.exports = __webpack_public_path__ + "img/salamanca.8c57f12a.jpg";